import assetPath from '../utils/assetPath';

const members = [
  {
    name: 'Aerokoca',
    role: 'Scout · Driver',
    bios: {
      en: 'Moves the squad quickly, scouts approaches before dismount, and keeps transport clean and on time.',
      fr: 'Positionne rapidement l’escouade, reconnaît les accès avant la descente et assure un transport fluide.',
    },
    instagram: 'https://www.instagram.com/vansoperator/',
    handle: '@vansoperator',
    tags: ['Recon', 'Driver', 'Support'],
    image: assetPath('/assets/aero.png'),
  },
  {
    name: 'Flo',
    role: 'Scout · Flanker',
    bios: {
      en: 'Creates openings with flanks, times pushes carefully, and balances patience with pressure.',
      fr: 'Crée des ouvertures par les flancs, choisit le bon timing et équilibre patience et pression.',
    },
    instagram: 'https://www.instagram.com/flo_salty/',
    handle: '@flo_salty',
    tags: ['Recon', 'Flank', 'NVG'],
    image: assetPath('/assets/flo.jpg'),
  },
  {
    name: 'Last',
    role: 'Assault · Flex',
    bios: {
      en: 'Flexible assault player who fills gaps, switches lanes fast, and steadies the stack under pressure.',
      fr: 'Assaut polyvalent, comble les brèches, change de ligne vite et stabilise l’équipe sous pression.',
    },
    instagram: 'https://www.instagram.com/last_rsoft/',
    handle: '@last_rsoft',
    tiktok: 'https://www.tiktok.com/@saltylast?lang=en',
    tiktokHandle: '@saltylast',
    youtube: 'https://www.youtube.com/@Salty_Last',
    youtubeHandle: '@Salty_Last',
    youtubeChannelId: 'UCp8iL9FjbBQ2kyRIZq5Nwug',
    tags: ['Assault', 'Flex', 'Support'],
    image: assetPath('/assets/last.png'),
  },
  {
    name: 'Nameless',
    role: 'Assault · Pointman',
    bios: {
      en: 'Pointman who clears first, calls corners fast, and keeps the entry moving.',
      fr: 'Pointman qui passe en premier, annonce vite les angles et maintient la progression.',
    },
    instagram: 'https://www.instagram.com/nameless_jpg/',
    handle: '@nameless_jpg',
    tags: ['CQB', 'Breacher', 'Assault'],
    image: assetPath('/assets/nameless.png'),
  },
  {
    name: 'Rosto',
    role: 'Scout · Hype Guy',
    bios: {
      en: 'Moves light, marks threats early, and keeps morale steady over long games.',
      fr: 'Avance léger, signale tôt les menaces et maintient le moral sur la durée.',
    },
    instagram: 'https://www.instagram.com/hugo_rosto/',
    handle: '@hugo_rosto',
    youtube: 'https://www.youtube.com/@rostorsoft',
    youtubeHandle: '@rostorsoft',
    youtubeChannelId: 'UCLCsjVLTjD56JopoiqnvY2g',
    tiktok: 'https://www.tiktok.com/@rosto_rsoft',
    tiktokHandle: '@rosto_rsoft',
    tags: ['Recon', 'Vibes', 'NVG', 'Drone'],
    image: assetPath('/assets/rosto.png'),
  },
  {
    name: 'Sergueï',
    role: 'Assault · Tag',
    bios: {
      en: 'Drives entries with controlled aggression, calls rotations mid-push, and locks firing lanes for the stack.',
      fr: 'Pousse l’entrée avec agressivité maîtrisée, annonce les rotations et verrouille les axes de tir.',
    },
    instagram: 'https://www.instagram.com/salty.serguei__/',
    handle: '@salty.serguei__',
    tags: ['Assault', 'Support'],
    image: assetPath('/assets/serguei.jpg'),
  },
  {
    name: 'Snow',
    role: 'CQB Breacher · Lead',
    bios: {
      en: 'Lead breacher who drives tempo, reads the room quickly, and makes decisive calls.',
      fr: 'Breacher lead qui impose le tempo, lit vite la pièce et prend des décisions nettes.',
    },
    instagram: 'https://www.instagram.com/snow_rsoft/',
    handle: '@snow_rsoft',
    youtube: 'https://www.youtube.com/@snow3994',
    youtubeHandle: '@snow3994',
    youtubeChannelId: 'UCs1DkxLdjLMRSmVkN0DE37w',
    tags: ['CQB', 'Breacher', 'Lead', 'NVG'],
    image: assetPath('/assets/snow.jpeg'),
  },
  {
    name: 'Toinoux',
    role: 'CQB Anchor · Support',
    bios: {
      en: 'Anchors rooms when the push slows, supports entries, and keeps comms tight.',
      fr: 'Verrouille les pièces quand la poussée ralentit, soutient les entrées et maintient des communications claires.',
    },
    instagram: 'https://www.instagram.com/toinouuuxi/',
    handle: '@toinouuuxi',
    tags: ['CQB', 'Support', 'Anchor'],
    image: assetPath('/assets/toinouxxx.png'),
  },
  {
    name: 'Val',
    role: 'Scout · Overwatch',
    bios: {
      en: 'Maintains calm overwatch on the perimeter, delivers concise callouts, and shifts inside when needed.',
      fr: 'Assure une surveillance calme en périphérie, fournit des annonces concises et entre si besoin.',
    },
    instagram: 'https://www.instagram.com/val.rsoft/',
    handle: '@val.rsoft',
    tags: ['Recon', 'Overwatch', 'Support'],
    image: assetPath('/assets/val.png'),
  },
];

export default members;
